import Hero from "./components/Hero";
import FeaturedBrands from "./components/FeaturedBrands";
import NavigationHub from "./components/NavigationHub";
import QuoteCTA from "./components/QuoteCTA";
import usePageSEO from "@/hooks/usePageSEO";
import JsonLd from "@/components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://ghbeauty.kr";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "GH Corporation",
  "url": siteUrl,
  "description": "GH Corporation supplies authentic Korean cosmetics from 125+ leading brands to importers, distributors and retailers worldwide. Multi-brand sourcing, FCL LCL air freight, export documentation and logistics from Korea.",
  "email": "kwonkhkorea@gmail.com",
  "telephone": "+82-10-4270-0614",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "114 Yeomjeon-ro, Michuhol-gu",
    "addressLocality": "Incheon",
    "addressCountry": "KR"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "sales",
    "name": "Kihwan Kwon",
    "email": "kwonkhkorea@gmail.com",
    "telephone": "+82-10-4270-0614",
    "availableLanguage": ["English", "Korean"]
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "18:00",
    "timeZone": "Asia/Seoul"
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "GH Corporation",
  "url": siteUrl,
  "description": "Korean cosmetics export partner — multi-brand sourcing, FCL LCL air freight and global logistics from Korea.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": siteUrl + "/brands?search={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  usePageSEO({
    title: "GH Corporation | Korean Cosmetics Export & K-Beauty Wholesale",
  });

  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <Hero />
      <FeaturedBrands />
      <NavigationHub />
      <QuoteCTA />
    </>
  );
}